<template>
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.4595 5.62469L0.609619 0.812348L1.39049 0.187653L5.24037 5H6.75974L10.6096 0.187653L11.3905 0.812348L7.54061 5.62469C7.35084 5.86191 7.06352 6 6.75974 6H5.24037C4.93658 6 4.64927 5.86191 4.4595 5.62469Z"
      fill="#878787" />
  </svg>
</template>

<script>
export default {
  name: "OpenIndicator",
};
</script>
